import Vue from 'vue';
export var EventBus = new Vue();